module.exports = __webpack_public_path__ + "img/img-22.64291a17.webp";